<!-- Organization Switcher Container -->
<div class="tw-flex tw-flex-col tw-h-full">
  <!-- Header with Back Button -->
  <div class="tw-px-4 tw-py-3 tw-bg-white dark:tw-bg-gray-900 tw-flex tw-items-center tw-gap-3 tw-border-b tw-border-gray-200 dark:tw-border-gray-700">
    <button
      (click)="closeRequested.emit()"
      [ngClass]="{ 'tw-rotate-180': isRTL() }"
      class="tw-p-2 tw-rounded-lg dark:tw-bg-gray-800 hover:tw-bg-gray-200 dark:hover:tw-bg-gray-700 tw-transition-colors"
    >
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.8688 20C13.3542 19.9999 12.8607 19.7894 12.4968 19.4147L4.73467 11.4245C4.37087 11.0499 4.1665 10.542 4.1665 10.0123C4.1665 9.4826 4.37087 8.9746 4.73467 8.60001L12.4968 0.609827C12.6758 0.419041 12.89 0.266864 13.1267 0.162174C13.3635 0.0574851 13.6181 0.00238022 13.8758 7.54214e-05C14.1334 -0.00222938 14.389 0.0483115 14.6274 0.14875C14.8659 0.249188 15.0826 0.397512 15.2648 0.585067C15.447 0.772622 15.5911 0.995652 15.6887 1.24114C15.7862 1.48663 15.8353 1.74967 15.8331 2.0149C15.8309 2.28014 15.7773 2.54225 15.6756 2.78596C15.5739 3.02967 15.4261 3.25009 15.2407 3.43436L8.85055 10.0123L15.2407 16.5902C15.5121 16.8696 15.6968 17.2254 15.7716 17.6129C15.8465 18.0003 15.8081 18.4019 15.6612 18.7668C15.5144 19.1318 15.2657 19.4437 14.9467 19.6632C14.6276 19.8827 14.2525 19.9999 13.8688 20Z"
          fill="#9CA3AF"
        />
      </svg>
    </button>
    <h2 class="tw-text-lg tw-font-bold tw-text-gray-900 dark:tw-text-gray-100">
      {{ 'v2.header.SWITCH_ORGANIZATION' | translate }}
    </h2>
  </div>

  <!-- Search Bar -->
  <div class="tw-px-4 tw-py-3 tw-bg-gray-100 dark:tw-bg-gray-900">
    <div class="tw-relative">
      <div class="tw-absolute tw-inset-y-0 tw-flex tw-items-center tw-pointer-events-none tw-start-0 tw-ps-3">
        <svg class="tw-h-5 tw-w-5 tw-text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      <input
        type="text"
        [ngModel]="searchQuery()"
        (ngModelChange)="onSearchInputChange($event)"
        (keypress)="onSearchKeyPress($event)"
        [placeholder]="'v2.organizationModal.searchPlaceholder' | translate"
        class="tw-block tw-w-full tw-h-10 tw-border tw-border-gray-300 dark:tw-border-gray-600 tw-rounded-lg tw-leading-5 tw-bg-white dark:tw-bg-gray-700 tw-text-gray-900 dark:tw-text-white tw-placeholder-gray-500 dark:tw-placeholder-gray-400 focus:tw-outline-none focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-text-sm tw-ps-10 tw-pe-10"
      />
      <!-- Clear Search Button -->
      @if (searchQuery().trim().length > 0) {
      <button
        (click)="clearSearch()"
        type="button"
        class="tw-absolute tw-inset-y-0 tw-flex tw-items-center tw-cursor-pointer tw-text-gray-400 hover:tw-text-gray-600 dark:hover:tw-text-gray-300 tw-end-0 tw-pe-3"
      >
        <svg class="tw-h-5 tw-w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      }
    </div>
  </div>

  <!-- Content Area - Cards -->
  <div #scrollContainer class="tw-pe-4 tw-ps-4 tw-pb-4 scrollable-content tw-overflow-y-auto tw-flex-1" (scroll)="onScroll($event)">
    <!-- Unified Skeleton Loading State -->
    @if (shouldShowLoading()) {
    <div class="tw-space-y-4">
      @for (i of [1,2]; track i) {
      <div class="tw-border tw-rounded-lg tw-p-4 tw-bg-gray-50 dark:tw-bg-gray-800 tw-relative tw-overflow-hidden">
        <!-- Shimmer effect -->
        <div
          class="tw-absolute tw-inset-0 tw-bg-gradient-to-r tw-from-transparent tw-via-white/20 tw-to-transparent tw-transform tw-translate-x-full tw-animate-[shimmer_2s_infinite]"
        ></div>
        <div class="tw-flex tw-gap-3 tw-relative tw-z-10">
          <div class="tw-w-24 tw-h-24 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded-xl tw-animate-pulse"></div>
          <div class="tw-flex-1 tw-space-y-2">
            <div class="tw-h-5 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-w-3/4 tw-animate-pulse"></div>
            <div class="tw-h-4 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-w-1/2 tw-animate-pulse"></div>
            <div class="tw-flex tw-gap-2">
              <div class="tw-h-6 tw-w-12 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse"></div>
              <div class="tw-h-6 tw-w-12 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    }

    <!-- Error State -->
    @if (shouldShowError()) {
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-12 tw-px-4">
      <div class="tw-text-center">
        <svg class="tw-mx-auto tw-h-12 tw-w-12 tw-text-gray-400 dark:tw-text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 19.5c-.77.833.192 2.5 1.732 2.5z"
          />
        </svg>
        <h3 class="tw-mt-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-100">
          {{ 'v2.organizationModal.errorTitle' | translate }}
        </h3>
        <p class="tw-mt-1 tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">
          {{ 'v2.organizationModal.errorMessage' | translate }}
        </p>
        <div class="tw-mt-6">
          <button
            (click)="loadOrganizations()"
            class="tw-inline-flex tw-items-center tw-px-4 tw-py-2 tw-border tw-border-transparent tw-text-sm tw-font-medium tw-rounded-md tw-text-white tw-bg-blue-600 hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-blue-500"
          >
            {{ 'v2.organizationModal.retry' | translate }}
          </button>
        </div>
      </div>
    </div>
    }

    <!-- Organizations List -->
    @if (!isLoading() && !isSearching() && !error()) {
    <div class="tw-space-y-4">
      @for (org of filteredOrganizations(); track org.id) {
      <app-organization-card
        class="tw-m-1"
        [organization]="org"
        [isSelected]="isCurrentOrganization(org)"
        [isClickable]="true"
        [showManagedBy]="true"
        (cardClick)="onOrganizationSelected(org)"
      />
      }

      <!-- Infinite Scroll Loading Indicator - Skeleton Cards -->
      @if (isLoadingMore() && hasMorePages()) {
      <div class="tw-space-y-4 tw-mt-4">
        @for (i of [1,2]; track i) {
        <div class="tw-border tw-rounded-lg tw-p-4 tw-bg-gray-50 dark:tw-bg-gray-800 tw-relative tw-overflow-hidden">
          <!-- Shimmer effect -->
          <div
            class="tw-absolute tw-inset-0 tw-bg-gradient-to-r tw-from-transparent tw-via-white/20 tw-to-transparent tw-transform tw-translate-x-[-100%] tw-animate-[shimmer_2s_infinite]"
          ></div>
          <div class="tw-flex tw-gap-3 tw-relative tw-z-10">
            <div class="tw-w-24 tw-h-24 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded-xl tw-animate-pulse"></div>
            <div class="tw-flex-1 tw-space-y-2">
              <div class="tw-h-5 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-w-3/4 tw-animate-pulse"></div>
              <div class="tw-h-4 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-w-1/2 tw-animate-pulse"></div>
              <div class="tw-flex tw-gap-2">
                <div class="tw-h-6 tw-w-12 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse"></div>
                <div class="tw-h-6 tw-w-12 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      }

      <!-- No More Organizations Message -->
      @if (!isLoadingMore() && hasMorePages() === false) {
      <div class="tw-text-center tw-py-4">
        <p class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">
          {{ 'v2.organizationModal.noMoreOrganizations' | translate }}
        </p>
      </div>
      }
    </div>
    }

    <!-- No Organizations Found State -->
    @if (shouldShowNoResults()) {
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-12 tw-px-4">
      <div class="tw-text-center">
        <!-- Default organization icon -->
        <svg class="tw-mx-auto tw-h-16 tw-w-16 tw-text-gray-400 dark:tw-text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1"
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          />
        </svg>
        <h3 class="tw-mt-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-100">
          {{ 'v2.organizationModal.noResultsFound' | translate }}
        </h3>
      </div>
    </div>
    }
  </div>
</div>
